module.exports = __webpack_public_path__ + "static/media/covi_aid_fir_aid.9d5cde37.png";